import axios, { AxiosError, type AxiosResponse } from 'axios'
import type { ApiResponse, AxiosDataResponse } from '../../../config/api-types'
import { AUTH_ENDPOINTS } from '../../../config/endpoints'
import type { IAuthClient } from '../data/data-sources/i-auth-client'
// import { ErrorMappingService } from '../../../services/error-mapping.service'

export class AuthService implements IAuthClient {
  async getToken(key: string): Promise<ApiResponse> {
    try {
      axios.defaults.baseURL = `${import.meta.env.VITE_REACT_APP_API_URL}/`
      axios.defaults.headers.common['x-api-version'] = Number(
        import.meta.env.VITE_REACT_APP_API_VERSION,
      )
      axios.defaults.headers.common['x-application-key'] = key
      
      const result: AxiosResponse<AxiosDataResponse> = await axios.get(
        AUTH_ENDPOINTS.auth,
      )

      return {
        data: result.headers['x-application-token'],
        status: result.status!,
        success: result.data.success!,
      }
    } catch (error) {
      const axiosError = error as AxiosError<AxiosDataResponse>

      return {
        message: axiosError.response?.data.data,
        success: false,
        status: axiosError.response?.status!,
      }
    }
  }
}
